import { useState } from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { useAuth } from './useAuth';
import { useSettings } from '../settings/useSettings';
import { ChangePasswordModal } from './ChangePasswordModal';
import { DEFAULT_SECURITY_SETTINGS } from '../../shared/types/settings';
import styles from './PasswordExpiringBanner.module.css';

export function PasswordExpiringBanner() {
  const { userDoc } = useAuth();
  const { settings } = useSettings();
  const [modalOpen, setModalOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [mountTime] = useState(() => Date.now());

  if (!userDoc || dismissed) return null;

  const expiresAt = userDoc.passwordExpiresAt;
  if (!expiresAt) return null;

  const warningDays =
    settings?.security?.passwordExpiryWarningDays ??
    DEFAULT_SECURITY_SETTINGS.passwordExpiryWarningDays;
  const ms = expiresAt.toMillis();

  // Se já expirou, Gate cuida — banner não mostra
  if (ms <= mountTime) return null;

  const daysLeft = Math.ceil((ms - mountTime) / (1000 * 60 * 60 * 24));
  if (daysLeft > warningDays) return null;

  return (
    <>
      <div className={styles.banner} role="status">
        <span className={styles.icon}><AlertTriangle size={18} /></span>
        <p className={styles.text}>
          Sua senha expira em <strong>{daysLeft} dia{daysLeft === 1 ? '' : 's'}</strong>.
          Recomendamos trocar agora.
        </p>
        <button type="button" className={styles.action} onClick={() => setModalOpen(true)}>
          Trocar agora
        </button>
        <button
          type="button"
          className={styles.dismiss}
          onClick={() => setDismissed(true)}
          aria-label="Dispensar aviso"
          title="Dispensar"
        >
          <X size={16} />
        </button>
      </div>
      <ChangePasswordModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
}
